export const COLUMNS = [
    {
        Header: "ID",
        accessor: "id",
        width: 50,
    },
    {
        Header: "Name",
        accessor: "name"
    },
    {
        Header: "Type",
        accessor: "type"
    },
    {
        Header: "Is Default",
        accessor: "is_default"
    },
    {
      Header: "",
      accessor: "action",
    }
]